import { render } from "./EntityCreation.vue?vue&type=template&id=28b82a9e&ts=true"
import script from "./EntityCreation.vue?vue&type=script&lang=ts"
export * from "./EntityCreation.vue?vue&type=script&lang=ts"

import "./EntityCreation.vue?vue&type=style&index=0&id=28b82a9e&lang=scss"

import exportComponent from "/home/vsts/work/1/s/src/CRM/OutlookAddin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__